<ng-container #emptyStatecontainer />
@if (!hasCustomComponent) {
  <span class="pt-2 pb-2 text-600 text-sm" aria-label="no-records-message">
    {{ 'common.LABELS.NO_RECORDS' | translate }}
  </span>
}
